<h3>Seção de Infobars</h3>
<form class="form-b4a" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="infobars-section">
    <h4>Infobars</h4>
    <div
      formArrayName="infobars"
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
    >
      <div
        *ngFor="let infobar of infobars.controls; let i = index"
        [formGroupName]="i"
        class="infobar-item p-card"
        cdkDrag
      >
        <div class="infobar-content">
          <span class="p-float-label">
            <input
              type="url"
              pInputText
              formControlName="link"
              id="link{{ i }}"
              name="link"
            />
            <label for="link{{ i }}">Link</label>
          </span>
          <span class="p-float-label">
            <input
              type="text"
              pInputText
              formControlName="text"
              id="text{{ i }}"
              name="text"
            />
            <label for="text{{ i }}">Texto * (max 45 caracteres)</label>
          </span>
        </div>
        <div class="inforbar-actions">
          <p-button
            type="button"
            icon="pi pi-arrows-alt"
            class="p-button-text p-button-rounded p-mr-2"
            pTooltip="Arrastar para reordenar"
            cdkDragHandle
          />
          <p-button
            type="button"
            icon="pi pi-trash"
            severity="danger"
            (click)="removeInfobar(i)"
            class="p-button-sm remove-button"
          />
        </div>
      </div>
    </div>
    <p-button
      type="button"
      label="Adicionar Infobar"
      icon="pi pi-plus"
      (click)="addInfobar()"
      class="p-button-secondary"
    />
  </div>

  <span class="buttons">
    <p-button
      label="Voltar"
      severity="danger"
      routerLink="/configuracoes/mens/home"
    />
    <p-button label="Salvar" type="submit" [disabled]="!form.valid" />
  </span>
</form>
